var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.podcasts.length)?_c('div',{staticClass:"more-of-category"},[_c('PodcastList',{key:1,attrs:{"bucket":{
      name: ("More in " + (_vm.category.name)),
      items: _vm.podcasts,
      bucket_type: 'podcasts',
      media_size: 'thumbnail',
    },"display-name":false,"has-hover-state":true,"type":"podcast"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }